export default __webpack_public_path__ + "static/media/722.df578d7e.png";